import { useEffect, useMemo } from "react";

import { useRouteMatch } from "react-router-dom";

import localSettings from "../../config/LocalSettings";
import SceneLastViewModeType from "../../enum/SceneLastViewModeType";
import ActivityViewMode from "../../scene/activity/enum/ViewMode";
import DealViewMode from "../../scene/deal/enum/ViewMode";
import { convertStringToEnum } from "../enum";

const useSceneLastViewMode = <
  TEnum extends SceneLastViewModeType,
  TEnumValue extends TEnum[keyof TEnum]
>(
  path: string,
  viewModeType: TEnum,
  defaultViewMode: TEnumValue
) => {
  const routeMatch = useRouteMatch<{ viewMode: string }>(`${path}/:viewMode`);

  const localStorageViewKey = useMemo(() => {
    if (viewModeType === ActivityViewMode) {
      return "ACTIVITY";
    } else if (viewModeType === DealViewMode) {
      return "DEAL";
    }

    throw new Error("Invalid view mode type.");
  }, [viewModeType]);

  const viewMode = useMemo(() => {
    return routeMatch?.isExact ? routeMatch.params.viewMode : undefined;
  }, [routeMatch]);

  useEffect(() => {
    if (viewMode) {
      localSettings.setSceneLastViewMode(localStorageViewKey, viewMode);
    }
  }, [localStorageViewKey, viewMode]);

  return (
    convertStringToEnum(viewModeType, localSettings.getSceneLastViewMode(localStorageViewKey)) ||
    defaultViewMode
  );
};

export default useSceneLastViewMode;
